<template>
	<div>
		<div class="d-flex justify-space-between">
			<h2 class="mb-4">Button Library</h2>
			<v-btn color="primary" @click="showDialog()">Add Button</v-btn>
		</div>

		<br />
		<div class="d-flex flex-wrap justify-space-around align-stretch">
			<v-hover v-for="(entity, index) in entityList" :key="index" v-slot:default="{ hover }">
				<v-card :elevation="hover ? 4 : 2" width="340" class="mb-5">
					<div
						class="v-card__text pa-0 checkered_background"
						style="position: relative; height: 200px; max-height: 200px; overflow: auto;"
					>
						<div
							:style="{
								position: 'absolute',
								transformOrigin: 'top left',
								transform: entity.transform,
								margin: entity.margin
							}"
						>
							<v-btn
								v-if="entity.backgroundType === 'Color'"
								:class="'hotspot_btn button_library_' + entity.id"
								large
								:style="{
									backgroundColor: entity.background,
									borderRadius: entity.borderRadius + 'px',
									border: entity.borderWidth + 'px solid ' + entity.borderColor,
									width: entity.width + 'px',
									height: entity.height + 'px'
								}"
							>
								<div
									v-html="
										entity.value +
										'<style scoped>' +
										entity.css.replace(/button_library/g, 'button_library_' + entity.id) +
										'</style>'
									"
									style="text-transform: none"
								></div>
							</v-btn>
							<v-btn
								v-else
								:class="'hotspot_btn button_library_' + entity.id"
								large
								:style="{
									backgroundImage: 'url(' + entity.background + ')',
									borderRadius: entity.borderRadius + 'px',
									border: entity.borderWidth + 'px solid ' + entity.borderColor,
									width: entity.width + 'px',
									height: entity.height + 'px'
								}"
							>
								<div
									v-html="
										entity.value +
										'<style scoped>' +
										entity.css.replace(/button_library/g, 'button_library_' + entity.id) +
										'</style>'
									"
								></div>
							</v-btn>
						</div>
					</div>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" @click="showEdit(entity)">
									<v-icon>mdi-pencil</v-icon>
								</v-btn>
							</template>
							<span>Edit Room</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" @click="deleteButtonLibrary(entity.id)">
									<v-icon color="red">mdi-delete</v-icon>
								</v-btn>
							</template>
							<span>Delete Room</span>
						</v-tooltip>
					</v-card-actions>
				</v-card>
			</v-hover>
		</div>

		<!-- eager and v-if dialogAdd for card to prevent blank tinyMCE editor -->
		<v-dialog v-model="dialogAdd" max-width="1000" persistent eager>
			<v-card v-if="dialogAdd">
				<v-card-title>Add Button</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12">
							<v-form ref="displayButtonLibrary">
								<div class="text-center checkered_background" style="padding: 50px 50px; border: 2px solid; min-height: 150px;">
									<v-btn
										v-if="entity.backgroundType === 'Color'"
										class="hotspot_btn button_library"
										large
										:style="{
											backgroundColor: entity.background,
											borderRadius: entity.borderRadius + 'px',
											border: entity.borderWidth + 'px solid ' + entity.borderColor,
											width: entity.width + 'px',
											height: entity.height + 'px'
										}"
									>
										<div v-html="entity.value + '<style scoped>' + entity.css + '</style>'" style="text-transform: none"></div>
									</v-btn>
									<v-btn
										v-else
										class="hotspot_btn button_library"
										large
										:style="{
											backgroundImage: 'url(' + entity.background + ')',
											borderRadius: entity.borderRadius + 'px',
											border: entity.borderWidth + 'px solid ' + entity.borderColor,
											width: entity.width + 'px',
											height: entity.height + 'px'
										}"
									>
										<div v-html="entity.value + '<style scoped>' + entity.css + '</style>'"></div>
									</v-btn>
								</div>
							</v-form>
							<br />
						</v-col>
						<v-col cols="6">
							<editor api-key="qd423wdft5go18d79gevmkpv8i92g9giyq6akdz5jc8ium67" :init="initTextEditor" v-model="entity.value" />
						</v-col>
						<v-col cols="6">
							<v-row>
								<v-col cols="6" style="padding: 0px 12px">
									<v-row>
										<v-col cols="6" style="padding: 0px 12px">
											<v-text-field v-model="entity.width" label="Width" type="number" hide-details></v-text-field>
										</v-col>
										<v-col cols="6" style="padding: 0px 12px">
											<v-text-field v-model="entity.height" label="height" type="number" hide-details></v-text-field>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="6" style="padding: 0px 12px">
									<v-slider
										v-model="entity.borderRadius"
										color="primary"
										label="Border Radius"
										min="0"
										max="50"
										thumb-label
										style="margin-top: 10px; margin-bottom: 10px"
										hide-details
									></v-slider>
								</v-col>
								<v-col cols="6" style="padding: 0px 12px">
									<v-select
										v-model="entity.backgroundType"
										:items="['Color', 'Upload']"
										label="Type"
										@change="changeBackground()"
									></v-select>
								</v-col>
								<v-col cols="6" style="padding: 0px 12px">
									<v-slider
										v-model="entity.borderWidth"
										color="primary"
										label="Border Size"
										min="0"
										max="10"
										thumb-label
										style="margin-top: 20px; margin-bottom: 10px"
										hide-details
									></v-slider>
								</v-col>
								<v-col cols="6" style="padding: 0px 12px" v-if="entity.backgroundType === 'Upload'">
									<input
										ref="attachment1"
										type="file"
										accept="image/png, image/jpeg, image/jpg, video/mp4"
										@change="onBackgroundUpload"
										style="display: none"
									/>
									<v-text-field
										v-model="backgroundFileName"
										label="Background"
										placeholder="Upload Background"
										prepend-icon="mdi-image"
										@click="openBackgroundDialog()"
										readonly
										:rules="[(v) => !!v || 'image is required']"
									>
									</v-text-field>
								</v-col>
								<v-col cols="6" style="padding: 0px 12px" v-else>
									<v-text-field v-model="entity.background" label="Background Color">
										<template v-slot:append v-if="entity.backgroundType === 'Color'">
											<v-menu
												v-model="backgroundColorPicker"
												top
												nudge-bottom="40"
												nudge-left="16"
												:close-on-content-click="false"
											>
												<template v-slot:activator="{ on }">
													<v-icon v-on="on">mdi-palette</v-icon>
												</template>
												<v-card>
													<v-card-text class="pa-0">
														<v-color-picker v-model="entity.background" flat />
													</v-card-text>
												</v-card>
											</v-menu>
										</template>
									</v-text-field>
								</v-col>
								<v-col cols="6" style="padding: 0px 12px">
									<v-text-field v-model="entity.borderColor" label="border Color">
										<template v-slot:append>
											<v-menu v-model="borderColorPicker" top nudge-bottom="40" nudge-left="16" :close-on-content-click="false">
												<template v-slot:activator="{ on }">
													<v-icon v-on="on">mdi-palette</v-icon>
												</template>
												<v-card>
													<v-card-text class="pa-0">
														<v-color-picker v-model="entity.borderColor" flat />
													</v-card-text>
												</v-card>
											</v-menu>
										</template>
									</v-text-field>
								</v-col>
								<v-col cols="12">
									<v-textarea
										v-model="entity.css"
										outlined
										label="CSS"
										value=""
										:placeholder="placeholderCss"
										@blur="resetDisplay"
									></v-textarea>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogAdd = false">Cancel</v-btn>
					<v-btn color="primary" @click="save">Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>


<script>
import axios from "axios";
import Editor from "@tinymce/tinymce-vue";

export default {
	components: {
		editor: Editor
	},
	data() {
		return {
			dialogAdd: false,
			entityList: null,
			entity: {
				value: "Button",
				css: "",
				width: 110,
				height: 35,
				background: "#F5F5F5FF",
				borderColor: "#F5F5F5FF",
				borderWidth: 0,
				borderRadius: 0,
				backgroundType: "Color"
			},
			backgroundColorPicker: false,
			borderColorPicker: false,
			backgroundFileName: "",
			attachment1: null,
			initTextEditor: {
				height: 360,
				menubar: false,
				plugins: [
					"advlist autolink lists link image charmap print preview anchor",
					"searchreplace visualblocks code fullscreen",
					"insertdatetime media table paste code help wordcount"
				],
				toolbar1: "undo redo | formatselect",
				toolbar2: "fontselect | fontsizeselect",
				toolbar3: "alignleft aligncenter alignright | bold italic underline | forecolor backcolor | link",
				fontsize_formats: '1pt 2pt 3pt 4pt 5pt 6pt 7pt 8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt'
			},
			placeholderCss: ".button_library {\n\tcolor: blue !important;\n}"
		};
	},
	mounted() {
		this.list();

		this.$root.appendTinyMCECustomFonts(this.initTextEditor);
	},
	methods: {
		list() {
			axios.get("/system/buttonlibrary/list").then((response) => {
				if (response.data) {
					this.entityList = response.data;
					for (let entity of this.entityList) {
						this.setCenter(entity, 1.0, entity.width, entity.height);
					}
				}
			});
		},
		setCenter(entity, scale, width, height) {
			let x = (340 - parseInt(width)) / 2;
			let y = (200 - parseInt(height)) / 2;

			if (x <= 0 || y <= 0) {
				scale = scale - 0.1;
				width = entity.width * scale;
				height = entity.height * scale;

				this.setCenter(entity, scale, width, height);
			} else {
				entity.transform = "scale(" + scale + ")";
				entity.margin = y + "px " + x + "px";
			}
		},
		showDialog() {
			this.setDefaultData();
			this.dialogAdd = true;
		},
		showEdit(entity) {
			this.entity.id = entity.id;
			this.entity.value = entity.value;
			this.entity.css = entity.css;
			this.entity.width = entity.width;
			this.entity.height = entity.height;
			this.entity.background = entity.background.startsWith("#") && entity.background.length < 8 ? entity.background + "FF" : entity.background;
			this.entity.borderColor = entity.borderColor.startsWith("#") && entity.borderColor.length < 8 ? entity.borderColor + "FF" : entity.borderColor;
			this.entity.borderWidth = entity.borderWidth;
			this.entity.borderRadius = entity.borderRadius;
			this.entity.backgroundType = entity.backgroundType;
			this.dialogAdd = true;
		},
		deleteButtonLibrary(id) {
			if (confirm("Are you sure you want to delete?")) {
				axios.post("/system/buttonlibrary/delete", { id: id }).then(() => {
					this.list();
				});
			}
		},
		setDefaultData() {
			this.entity.id = null;
			this.entity.value = "Button";
			this.entity.css = "";
			this.entity.width = 110;
			this.entity.height = 35;
			this.entity.background = "#F5F5F5FF";
			this.entity.borderColor = "#F5F5F5FF";
			this.entity.borderWidth = 0;
			this.entity.borderRadius = 0;
			this.entity.backgroundType = "Color";
			this.attachment1 = null;
			this.backgroundFileName = "";
		},
		save() {
			let formData = new FormData();
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
				this.entity.background = "";
			}
			formData.append("entity", JSON.stringify(this.entity));

			let url = this.entity.id ? "/system/buttonlibrary/edit" : "/system/buttonlibrary/add";
			axios.post(url, formData).then(() => {
				this.dialogAdd = false;
				this.list();
			});
		},
		onBackgroundUpload(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					this.entity.background = fr.result;
					this.attachment1 = files[0]; // this is an image file that can be sent to server...
				});
				this.backgroundFileName = files[0].name + " (" + files[0].size / 1000 + "kB)";
			} else {
				this.attachment1 = null;
			}
		},
		changeBackground() {
			if (this.entity.backgroundType === "Color") {
				this.entity.background = "#F5F5F5FF";
				this.backgroundFileName = "";
				this.attachment1 = null;
			} else {
				this.entity.background = "";
			}
		},
		openBackgroundDialog() {
			this.$refs.attachment1.click();
		},
		resetDisplay() {
			this.$refs.displayButtonLibrary.reset();
		}
	}
};
</script>
